import { Alert, Button, Center, Group, Loader, Paper, Text, Title } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import { sporocilo } from '../api/napaka';
import classes from './Podatki.module.css';

/** Kartica z naslovom. */
export function Kartica({ naslov, children, dejanja }: { naslov?: string; children: ReactNode; dejanja?: ReactNode }) {
  return (
    <Paper radius="lg" p={{ base: 'md', sm: 'lg' }} shadow="xs">
      {(naslov || dejanja) && (
        <Group justify="space-between" align="center" wrap="nowrap" gap="sm" mb="sm">
          {naslov ? (
            <Title order={2} size="h4" style={{ minWidth: 0 }}>
              {naslov}
            </Title>
          ) : (
            <span />
          )}
          {dejanja && <div style={{ flexShrink: 0 }}>{dejanja}</div>}
        </Group>
      )}
      {children}
    </Paper>
  );
}

/** Seznam »oznaka: vrednost« v dveh stolpcih (na telefonu oznaka nad vrednostjo). */
export function Podatki({ vrstice }: { vrstice: [string, ReactNode][] }) {
  return (
    <div className={classes.podatki}>
      {vrstice.map(([oznaka, vrednost]) => (
        <div key={oznaka} style={{ display: 'contents' }}>
          <Text size="sm" c="dimmed">
            {oznaka}
          </Text>
          <Text size="sm" fw={500} className={classes.vrednost} component="div">
            {vrednost || '–'}
          </Text>
        </div>
      ))}
    </div>
  );
}

/** Nalaganje ali napaka pri nalaganju zaslona s podrobnostmi. */
export function StanjeNalaganja({ napaka, ponovi, naslov }: { napaka: unknown; ponovi: () => void; naslov: string }) {
  if (!napaka) {
    return (
      <Center py={80}>
        <Loader />
      </Center>
    );
  }
  return (
    <Alert color="red" variant="light" icon={<IconAlertCircle size={18} />} title={naslov} maw={640} mx="auto" mt="xl">
      <Text size="sm">{sporocilo(napaka)}</Text>
      <Button size="xs" variant="light" color="red" mt="sm" onClick={ponovi}>
        Poskusi znova
      </Button>
    </Alert>
  );
}
